import { SVGProps } from '@components/Icon/types';

export const EmailOutlined = ({
  fill = '#000',
  size = 24,
  ...props
}: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    {...props}>
    <path
      d="M6 4.7002H18C19.8225 4.7002 21.2998 6.17746 21.2998 8V16C21.2998 17.8225 19.8225 19.2998 18 19.2998H6C4.17746 19.2998 2.7002 17.8225 2.7002 16V8C2.7002 6.17746 4.17746 4.7002 6 4.7002Z"
      stroke={fill}
      strokeWidth="1.4"
    />
    <path
      d="M20.5232 6.46505C20.78 6.17611 20.754 5.73366 20.4651 5.47681C20.1761 5.21997 19.7337 5.246 19.4768 5.53495L20.5232 6.46505ZM4.52319 5.53495C4.26634 5.246 3.82389 5.21997 3.53495 5.47681C3.246 5.73366 3.21997 6.17611 3.47681 6.46505L4.52319 5.53495ZM19.4768 5.53495L14.4665 11.1716L15.5128 12.1017L20.5232 6.46505L19.4768 5.53495ZM9.53355 11.1716L4.52319 5.53495L3.47681 6.46505L8.48718 12.1017L9.53355 11.1716ZM14.4665 11.1716C13.1537 12.6484 10.8463 12.6484 9.53355 11.1716L8.48718 12.1017C10.3568 14.205 13.6432 14.205 15.5128 12.1017L14.4665 11.1716Z"
      fill={fill}
    />
  </svg>
);

export const ICON_NAME = 'emailOutlined';
